import type { FC } from 'react';
import { Text } from '@livechat/design-system-react-components';

import * as styles from './styles';

type Props = {
  email: string;
};

export const Description: FC<Props> = ({ email }) => (
  <div css={styles.stopTextContainer} data-testid="stop-screen-main-text-container">
    <div css={styles.firstLine}>
      <Text>We sent the code to </Text>
      <Text bold>{email}.</Text>
    </div>
    <div>
      <Text>Go to your inbox, copy the code and paste it below to confirm your email.</Text>
    </div>
  </div>
);
